import { ReactNode } from 'react';

import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';
import { Text } from '@/components/shared/components/Text';

interface DiagramTextProps {
  x: number;
  y: number;
  /** Suffix of a LENDER_ORCHESTRATION_DIAGRAM_ key, rendered after `children`. */
  tId?: string;
  children?: ReactNode;
  tone?: TextTone;
  small?: boolean;
  bold?: boolean;
  anchor?: 'start' | 'middle' | 'end';
}

export const DiagramText = ({
  x,
  y,
  tId,
  children,
  tone = TextTone.DEFAULT,
  small = false,
  bold = false,
  anchor = 'middle',
}: DiagramTextProps) => {
  const { colors } = useDiagramContext();

  return (
    <text
      x={x}
      y={y}
      textAnchor={anchor}
      fill={colors.text[tone]}
      fontSize={small ? 9.5 : 11}
      fontWeight={bold ? 700 : 400}
    >
      {children}
      {tId && <Text tId={`LENDER_ORCHESTRATION_DIAGRAM_${tId}`} />}
    </text>
  );
};
